<div class="justify-center items-center">
  <button mat-button disabled class="client-button">{{currentClient ? currentClient.name : ''}}</button>
  <mat-icon>keyboard_arrow_right</mat-icon>
  @if (currentBranch && currentCashRegister) {
    <button mat-button [matMenuTriggerFor]="branchMenu">{{currentBranch ? currentBranch.name : ''}}</button>
    <mat-menu #branchMenu="matMenu">
      @for (branch of branches; track branch) {
        <button mat-menu-item (click)="setCurrentBranch(branch)" [disabled]="branch['uid'] === currentBranch['uid']"  [ngClass]="{'unClickable disabled': branch.cashRegister.length === 0}">
          <mat-icon>store</mat-icon>
          <span>{{branch['name']}}</span>
        </button>
      }
    </mat-menu>
    <mat-icon>keyboard_arrow_right</mat-icon>
    <button mat-button [matMenuTriggerFor]="crMenu" color="primary">{{currentCashRegister ? currentCashRegister['name'] : ''}}</button>
    <mat-menu #crMenu="matMenu">
      @for (cr of currentBranch.cashRegister; track cr) {
        <button mat-menu-item (click)="setCurrentCashRegister(cr)" [disabled]="cr['uid'] === currentCashRegister['uid']">
          <mat-icon>local_printshop</mat-icon>
          <span>{{cr['name']}}</span>
        </button>
      }
    </mat-menu>
  }
</div>
